import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/70">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-[1fr_1.6fr]">
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-accent-600">FAQ</p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-600">
            关于工口游戏的选购、评分与游玩，这里汇总了新手最常问的问题。
            如果还有疑问，欢迎通过页脚的邮箱与我们联系。
          </p>
        </div>

        <div className="divide-y divide-background-200/80 rounded-2xl border border-background-200/70 bg-background-50">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform ${isOpen ? "rotate-45" : ""}`}>
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}